import { render, staticRenderFns } from "./DmmLetterProcess.vue?vue&type=template&id=722dba51&scoped=true"
import script from "./DmmLetterProcess.vue?vue&type=script&lang=js"
export * from "./DmmLetterProcess.vue?vue&type=script&lang=js"
import style0 from "./DmmLetterProcess.vue?vue&type=style&index=0&id=722dba51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722dba51",
  null
  
)

export default component.exports